module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.visible) ? _c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('div', {
    class: _vm.mainClasses
  }, [_c('span', {
    class: _vm.dotClasses
  }), _vm._v(" "), _c('div', {
    class: _vm.textClasses
  }, [_vm._t("default")], 2)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de3ba438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/loading.vue
// module id = 414
// module chunks = 0